import React from 'react';

import { trackEvent } from '../../../../../shared/services/utils/tracking/tracking.service';
import Modal from '../../../../../shared/components/core-ui/modal/modal.component';
import Button, {
  ButtonSize,
  ButtonType
} from '../../../../../shared/components/core-ui/button/button.component';
import useWindowResizer from '../../../../../shared/hooks/window-resizer/window-resizer.hook';
import { CompanyUiModel } from '../../../../../shared/ui-models/company.ui-model';

export interface DeleteCompanyModalProps {
  data: {
    company?: CompanyUiModel;
  };
  config: {
    showModal: boolean;
  };
  eventHandlers: {
    cancelHandler: () => void;
    deleteCompanyHandler: (company: CompanyUiModel) => void;
  };
}

export const DeleteCompanyModal: React.FC<DeleteCompanyModalProps> = ({
  data,
  config,
  eventHandlers
}) => {
  const isMobileView = useWindowResizer();

  const handleDeleteCompanySubmit = () => {
    if (data && data.company) {
      eventHandlers.deleteCompanyHandler(data.company);
    }
  };

  return (
    <Modal
      config={{ showModal: config.showModal, fullScreen: false, showClose: false }}
      eventHandlers={{
        closeModalHandler: () => {
          eventHandlers.cancelHandler();
        }
      }}
    >
      <div className="flex flex-col gap-3 px-6 py-4">
        <div className="text-2xl font-gilroy-bold font-semibold text-neutral-900">
          Delete Company
        </div>
        <div className="text-xl font-gilroy-medium text-neutral-500">
          {`Are you sure you want to delete ${data.company?.name}?`}
        </div>
      </div>
      <div className="flex flex-col gap-3 px-6 pb-6 sm:flex-row sm:justify-end">
        <Button
          onClick={() => {
            eventHandlers.cancelHandler();
            trackEvent('record_edit_cancelled', { entity: 'company', method: 'cancel' });
          }}
          tracking={{ event: 'record_edit_cancelled', entity: 'company', method: 'cancel' }}
          size={isMobileView ? ButtonSize.full : ButtonSize.medium}
          type={ButtonType.primaryInverted}
        >
          Cancel
        </Button>
        <Button
          onClick={handleDeleteCompanySubmit}
          tracking={{
            event: 'record_saved',
            entity: 'company',
            action: 'update',
            outcome: 'success'
          }}
          type={ButtonType.danger}
          size={isMobileView ? ButtonSize.full : ButtonSize.medium}
        >
          Delete
        </Button>
      </div>
    </Modal>
  );
};
